module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/kv_img@sp-8f58f4c42a77c2205e80da8ced58431a.jpg";